const ProductDescription = {
  UPC: '',
  brandName: '',
  productName: '',
  Manufacturer: '',
  distbInCA: true,
  RetailPrice: 0.0,
  FederalNutrition: true,
  //ReviewOneFollowUp: false,
  //ReviewTwoFollowUp: false,
}

export default ProductDescription
